export default class FileHelper {
    /**
     *
     * @type {{}}
     */
    static data: { max_post_size?: number } = {};

    static getMaxPostSize() {
        return FileHelper?.data?.max_post_size;
    }
}
